const utils = require('../../../lib/utils')

module.exports = {
	config: {
		registerSecret: 'mediaList',
		registerType: 'component',
		forceDomUpdate: 10
	},

	model: {
		mediaList: {},
		selectedMedia: {},
		selectedMediaIndex: 0,

		configsInitialized: false,
		fieldConfig: {},
		managementConfig: {},
		listOfMediaIDs: null,
		showNonReusablesAsWell: false,

		lazyloadStepSize: 30, // 30 rows
		lazyloadingInEffect: false,
		nrOfElements: {
			nrOfElements: 0,
			nrOfMatchingElements: 0,
			nrOfNonMatchingElements: 0
		}
	},

	events: {
		markFile: {
			type: 'click',
			action: function (event) {
				event.preventDefault()
				event.stopImmediatePropagation()
				var $target
				var mediaID = ($target = $(event.target).closest('.base_form_media_file_file')).data('mediaId')
				if(mediaID){
					utils.performButtonAction(event, undefined, { mediaID: mediaID }).then(function(context){
						var self = event.data.component
						if(!context.actionPerformed){
							// deselect file
							if($target.hasClass('selected')){
								$target.removeClass('selected')
								self.model.selectedMedia[mediaID] = -1
							}
							else {
								// prepare
								var managementConfig    = self.model.managementConfig
								if(managementConfig.multiSelect !== false && managementConfig.maxNrOfElements <= 1){
									managementConfig.multiSelect = false
								}

								// deselect all => multi selection not allowed
								if(managementConfig.multiSelect === false){
									if(utils.collectionSize(self.model.selectedMedia) > 0){
										self.$.find('[data-media-id="' + Object.keys(self.model.selectedMedia).join('"],[data-media-id="') + '"]').removeClass('selected')
										self.model.selectedMedia = {}
										self.model.selectedMediaIndex = 0
									}
								}
								// deselect selected files until maxNrOfElements-limit is not violated any longer if necessary starting with the earliest selection.
								else if(managementConfig.maxNrOfElements > 1 && self.model.selectedMediaIndex >= managementConfig.maxNrOfElements){
									var minMediaIndex = (self.model.selectedMediaIndex - managementConfig.maxNrOfElements + 1)
									for(var selectedMediaID in self.model.selectedMedia){
										if(self.model.selectedMedia[selectedMediaID] < minMediaIndex){
											delete self.model.selectedMedia[selectedMediaID]
											self.$.find('[data-media-id="' + selectedMediaID + '"]').removeClass('selected')
										}
									}
								}

								// select file
								$target.addClass('selected')
								self.model.selectedMedia[mediaID] = self.model.selectedMediaIndex++
							}
						}

						self.updateNrOfElements()
					})
				}
				else {
					console.error('mediaID undefined')
				}
			}
		},

		showFileDetailsSummary: {
			type: 'mouseenter',
			selector: '.base_form_media_file_file',
			action: function(event){
				var self = event.data.component
				var $target = $(event.target).closest('.base_form_media_file_file')
				if($target.length > 0){
					var mediaID = $target.data('mediaId')
					if(mediaID){
						var media = self.getMediaByID(mediaID)
						if(Object.keys(media).length > 0){
							self.triggerClosest('showMediaDetails', { media })
						}
					}
				}
			}
		},

		lazyloadClick: {
			type: 'click',
			selector: 'button[data-field-type="lazyload"]',
			action: function(event){
				event.preventDefault()
				event.stopImmediatePropagation()
				event.data.component.lazyloadNext()
			}
		},

		lazyloadScroll: {
			type: 'mousewheel DOMMouseScroll',
			action: function(event){
				event.data.component.onScrollLazyload($(event.target).closest('section.content'), event.data.component.$)
			}
		}
	},

	methods: {
		delete: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			var self = this
			if(additionalData.mediaID){
				var $target = self.$.find('[data-media-id="' + additionalData.mediaID + '"]').addClass('deletionInProgress')
				var messageBaseName = 'hint.delete.really.media'
				return self.performDecision(
					'confirm',
					{
						component:  self,
						title:      storage.__(messageBaseName + '.title'),
						message:    storage.__(messageBaseName + '.message')
					}
				).then(function(context) {
					if (context.decision.type === 'yes') {
						return self.performAction(
							self.prepareAction('deleteMedia', additionalData.mediaID)
						).then(function(context){
							$target.addClass('deleted')
							delete self.model.mediaList['mediaID_' + additionalData.mediaID]
							self.model.selectedMedia[additionalData.mediaID] = -1
							if(self.model.$newFileList.find('[data-media-id]:not(.deleted)').length === 0){
								self.model.$newFileContainer.removeClass('active')
							}
							self.updateNrOfElements()
						}).fail(function(error){
							$target.removeClass('deletionInProgress')
						})
					} else {
						$target.removeClass('deletionInProgress')
					}
				})
			}
		},

		initConfigs(){
			if(!this.model.configsInitialized){
				this.model.configsInitialized 	    = true
				this.model.fieldConfig              = this.getResourceRegisterContent('fieldConfig') || {}
				this.model.managementConfig         = this.model.fieldConfig.managementConfig || {}
				this.model.listOfMediaIDs 		    = this.getResourceRegisterContent('listOfMediaIDs') || []
				this.model.showNonReusablesAsWell	= utils.isEmpty(this.model.fieldConfig); // if mediaManagement gets opened via main nav entry without any field context non-reusables should be displayed as well.
			}
		},

		dataDealer: function(){
			this.initConfigs()
		},

		prepare: function(storage){
			const user = (storage || {}).user
			if(user) 	this.model.extendedButtonActionsGranted = user.hasAccessTo('usage:media:extendedButtonActions', this.scope);
			else 		this.model.extendedButtonActionsGranted = false;
		},

		sanitizeResources: function(storage){
			if(!this.config.isReady){
				this.model.mediaList = {}
			}

			var self 		= this
			var mediaList 	= this.model.mediaList
			var mediaKey
			var domFilePresent
			if(self.resourceData && self.resourceData.data && (!self.resourceData.initialized || self.model.lazyloadingInEffect)){
				self.resourceData.initialized = true
				utils.forEach(self.resourceData.data, function(file){
					self.prepareFileData(file, storage)
					// this key is necessary to prevent order issues
					mediaKey = 'mediaID_' + file.mediaID
					domFilePresent = self.model.lazyloadingInEffect && mediaList[mediaKey] && mediaList[mediaKey] !== -1
					delete mediaList[mediaKey]
					mediaList[mediaKey] = file
					// add lazyloaded files if necessary
					if(self.config.isReady && !domFilePresent){
						self.addFile(file, false)
					}
				})
				self.updateNrOfElements()
			}
			// filters may be too restrictive
			else if(storage.isClient){
				self.updateNrOfElements()
			}
		},

		getResourceFilters: function(){
			this.initConfigs()
			if(!this.model.resourceFilters) this.model.resourceFilters = {};
			const filters = this.model.resourceFilters
			filters.listOfMediaIDs = this.model.listOfMediaIDs
			filters.permissionsGrantedOnly = !this.hasAccessTo(`cms_media:permissions:mimicOwner`)
			filters.ownerOnly = (this.model.managementConfig || {}).ownerOnly
			if(!this.model.showNonReusablesAsWell) 	filters.isReusable = true;
			if(!this.config.isReady) 				filters.offset = 0;
			if(!filters.offset) 					filters.offset = 0;
			if(!filters.limit) 						filters.limit = filters.offset + (this.model.lazyloadStepSize || 0);

			// FILTER EXAMPLES:
			// filters.listOfCategoryDataIDs = [2]
			// filters.order = 'sizeInBytes'
			// filters.order = [{ field: 'originalName', direction: 'DESC' }]

			return filters
		},

		setFilter: function(field, value){
			if(!this.model.resourceFilters) this.model.resourceFilters = {}
			if(field) this.model.resourceFilters[field] = value;
			this.model.resourceFilters.offset = 0
			this.model.resourceFilters.limit = this.model.lazyloadStepSize
			this.model.mediaList = {}
			this.model.selectedMedia = {}
			this.model.selectedMediaIndex = 0
			this.refresh()
		},

		updateFilters: function(filters){
			utils.refReplace(this.model.resourceFilters, filters)
			this.setFilter()
		},

		onScrollLazyload($scrollContainer, $fullHeightContainer){
			this.delayedLastOf('onScrollLazyload', () => {
				if(
					$scrollContainer.length > 0 &&
					$fullHeightContainer.length > 0 &&
					($fullHeightContainer.height() - $scrollContainer.height() - $scrollContainer.scrollTop()) <= 50
				){
					this.lazyloadNext()
				}
			}, 100)
		},

		lazyloadNext: function(){
			var self = this
			// prevent lazyloading requests if the last lazyload contained no data
			if(!self.model.lazyloadingInEffect && (self.resourceData.data || []).length > 0){
				self.model.lazyloadingInEffect = true
				self.model.resourceFilters.offset += self.model.lazyloadStepSize
				self.performAction('refreshResources')
					.always(function(){
						self.model.lazyloadingInEffect = false
					})
				;
			}
		},

		selectAllMedia: function(){
			this.model.selectedMedia = {}
			this.model.selectedMediaIndex = 0
			for(var mediaKey in this.model.mediaList){
				this.model.selectedMedia[this.model.mediaList[mediaKey].mediaID] = this.model.selectedMediaIndex++
			}
			this.$.find('.base_form_media_file_file').addClass('selected')
			this.updateNrOfElements()
		},

		deselectAllMedia: function(){
			this.model.selectedMedia = {}
			this.model.selectedMediaIndex = 0
			this.$.find('.base_form_media_file_file').removeClass('selected')
			this.updateNrOfElements()
		},

		getSelectedMedia: function(){
			var self = this
			var selectedMedia = {}
			utils.forEach(self.model.selectedMedia, function(sortIndex, mediaID){
				if(sortIndex >= 0 && self.model.mediaList['mediaID_' + mediaID]){
					selectedMedia[sortIndex] = self.model.mediaList['mediaID_' + mediaID]
				}
			})
			return selectedMedia
		},

		getMediaByID: function(mediaID){
			var mediaKey = 'mediaID_' + mediaID
			if(mediaID && this.model.mediaList[mediaKey]){
				return this.model.mediaList[mediaKey]
			}
			return {}
		},

		updateMediaTagsByMediaID: function(mediaData){
			var mediaID, mediaKey, storage = this.getStorage()
			for(var m in mediaData || []){
				this.prepareFileData(mediaData[m], storage)
				mediaID = mediaData[m].mediaID
				mediaKey = 'mediaID_' + mediaID
				if(this.model.mediaList[mediaKey]){
					this.model.mediaList[mediaKey].tags 			= mediaData[m].tags
					this.model.mediaList[mediaKey].tagsResources 	= mediaData[m].tagsResources
				}
			}
		},

		prepareFileData: function(file, storage){
			utils.media.file.prepare(file, storage, 'web', this.scope)
		},

		addNewFile: function(file, prepend){
			file = file || {}
			var mediaList 	= this.model.mediaList
			var _primaryKey = file.primaryKey || 'mediaID'
			var primaryKey 	= file[_primaryKey]
			var mediaKey
			if(primaryKey){
				// this key is necessary to prevent order issues
				mediaKey = 'mediaID_' + primaryKey
				delete mediaList[mediaKey]
				mediaList[mediaKey] = file
				this.addFile(file, prepend, true)
				this.updateNrOfElements()
			} else {
				throw new Error('FILE-LIST MISSES THE PRIMARY KEY OF THE NEW FILE')
			}
		},

		addFile: function(file, prepend, newFile){
			// add file to dom if necessary
			if(this.config.isReady){
				var newFileTag = this.include('../../../base/form/media/file/file', { resourceData: file, config: { context: 'management', controls: { edit: false, renew: false, delete: true } }, model: { extendedButtonActionsGranted: this.model.extendedButtonActionsGranted } })
				if(newFile){
					this.model.$newFileContainer.addClass('active')
					if(prepend) this.model.$newFileList.prepend(newFileTag)
					else        this.model.$newFileList.append(newFileTag)
				} else {
					if(prepend) this.model.$fileList.prepend(newFileTag)
					else        this.model.$fileList.append(newFileTag)
				}
			}
		},

		handleError: function(context){
			if(context.action.originalActionKey === 'deleteMedia' && context.error.errorCode === 'USER_PROVIDER_ROUTE_PRIVILEGE_ERROR' && context.error.statusCode == 403){
				return this.performAction(this.prepareAction('message', undefined, {
					messageDisplay: {
						message: 'error:notAllowed.media.delete'
					}
				}))
			}

			context.errorUnhandled = true
			return utils.promise.resolve(context)
		},

		updateNrOfElements: function(){
			var nrOfElements = ((this.resourceData.nrOfElements || {}).data || {}).attributes || {}
			nrOfElements.nrOfShownElements = 0
			nrOfElements.sizeOfShownElements = 0
			nrOfElements.nrOfSelectedElements = 0
			nrOfElements.sizeOfSelectedElements = 0
			var mediaID, mediaKey
			for(mediaID in this.model.selectedMedia){
				if(this.model.selectedMedia[mediaID] !== -1){
					nrOfElements.sizeOfSelectedElements += (this.model.mediaList[`mediaID_${mediaID}`] || {}).sizeInBytes || 0
					nrOfElements.nrOfSelectedElements++
				}
			}
			for(mediaKey in this.model.mediaList){
				nrOfElements.nrOfShownElements++
				nrOfElements.sizeOfShownElements += (this.model.mediaList[mediaKey] || {}).sizeInBytes || 0
			}
			this.triggerClosest('updateNrOfElements', { nrOfElements })
		},
	},

	hooks: {
		initFileList: function($element, options){
			utils.forEach(this.model.mediaList, file => {
				this.addFile(file, false)
			})
		},

		attach: function($element, options){
			this.model.$fileList 			= $element.find('.fileList')
			this.model.$newFileContainer 	= $element.find('.newFiles')
			this.model.$newFileList 		= $element.find('.newFileList')
			if(!utils.isEmpty(this.model.mediaList)){
				// NOTE: init files after the init process has been completed to prevent long gui-idle-times
				this.triggerWhenReady('initFileList', {})
			}

			if(options.refresh){
				$element.closest('section.content').scrollTop(0)
			}
		},
	}
}